<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        />
        <b-col
          cols="12"
        >
          <b-form-group
            label="Video Bağlantısı"
            label-for="video_url"
          >
            <b-form-input
              id="url"
              v-model="videoUrl"
              placeholder="Video Bağlantısı"
              @input="getEmbedCode"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="text-center"
        >
          <b-embed
            v-if="itemData.video_embed"
            type="iframe"
            aspect="16by9"
            :src="youtubeUrl + itemData.video_embed"
          />
          <div
            v-else
            class="bg-light py-5 rounded text-muted"
          >
            <div class="my-2">
              <div>
                <FeatherIcon icon="VideoIcon" />
              </div>
              <div>
                Video Önizleme
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
      />
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCol, BFormGroup, BFormInput, BRow, BEmbed,
} from 'bootstrap-vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BEmbed,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      videoUrl: null,
      youtubeUrl: 'https://www.youtube.com/embed/',
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['services/dataItem']
    },
  },
  methods: {

    getEmbedCode() {
      this.$store.dispatch('services/getEmbedCode', this.videoUrl)
        .then(res => {
          this.itemData.video_embed = res.id
        })
    },
  },
}
</script>
